<template>
  <div id="app-main">
    <div class="row">
      <div class="col">
        <div class="page-title-box flex-between">
          <h4 class="page-title">访问分析</h4>
          <div class="page-title date-range">统计范围：{{ accessData.time }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <el-card>
          <div class="row mb-3 flex-between">
            <div class="col-2">
              <el-button type="primary" @click="exportTable">导出表格</el-button>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col">
              <el-table id="access-analyse-table" :data="accessTableData" stripe="">
                <el-table-column prop="rowIndex" label=""></el-table-column>
                <el-table-column prop="pv" label="浏览次数"></el-table-column>
                <el-table-column prop="uv" label="独立访客"></el-table-column>
                <el-table-column prop="ip" label="IP"></el-table-column>
                <el-table-column prop="access_num" label="访问次数"></el-table-column>
              </el-table>
            </div>
          </div>
          <el-row>
            <el-col>
              <div class="chart-title">流量趋势</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div class="timerange flex-between flex-align-center">
                <div>
                  <el-date-picker
                    v-if="curEnv === 'sysu'"
                    v-model="startDay"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择统计开始日期"
                    :picker-options="dayPickerOptions"
                    @change="startDayChange"
                  ></el-date-picker>
                  <span v-if="curEnv === 'sysu'">至</span>
                  <el-date-picker
                    v-if="curEnv === 'sysu'"
                    v-model="endDay"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择统计结束日期"
                    :picker-options="dayPickerOptions"
                    @change="endDayChange"
                  ></el-date-picker>
                </div>

                <el-radio-group size="mini" v-model="accessPeriod" @change="changeChartPeriod">
                  <el-radio-button label="1">近三十天</el-radio-button>
                  <el-radio-button label="2">近一年</el-radio-button>
                </el-radio-group>
              </div>
            </el-col>
          </el-row>
          <div class="chart-card">
            <div id="flow-trend-chart" :style="{ height: '400px' }"></div>
          </div>
          <div class="row flex-end"></div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { dislodgeZero, timestampToTime } from '@/utils/format.js'

export default {
  data() {
    return {
      accessPeriod: '1',
      accessData: [],
      accessTableData: [],
      flowTrendChart: null,
      screenWidth: '',
      screenHeight: '',
      startDay: '',
      endDay: '',
      dayPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now() - 86400000
        },
      },
    }
  },
  computed: {
    dayChartData() {
      let data = {}
      let x = []
      let browserTimes = []
      let uniqueVisitor = []
      let ip = []
      for (let i of this.accessData.day_chart) {
        let formatTime = i.time.substring(5).replace('-', '.')

        x.push(dislodgeZero(formatTime))
        browserTimes.push(i.pv)
        uniqueVisitor.push(i.uv)
        ip.push(i.ip)
      }
      data['x'] = x
      data['browserTimes'] = browserTimes
      data['uniqueVisitor'] = uniqueVisitor
      data['ip'] = ip
      data['yType'] = 'value'
      console.log('11', data)

      return data
    },
    monthChartData() {
      let data = {}
      let x = []
      let browserTimes = []
      let uniqueVisitor = []
      let ip = []
      for (let i of this.accessData.month_chart) {
        x.push(i.time)
        browserTimes.push(i.pv)
        uniqueVisitor.push(i.uv)
        ip.push(i.ip)
      }
      data['x'] = x
      data['browserTimes'] = browserTimes
      data['uniqueVisitor'] = uniqueVisitor
      data['ip'] = ip
      data['yType'] = 'log'
      console.log('22', data)

      return data
    },
    pickDatePeriod() {
      // return this.accessPeriod === '1' ? 30 : 365
      return this.accessPeriod === '1' ? 29 : 364
    },
    curEnv() {
      return process.env.VUE_APP_MODE
    },
    yesterday() {
      let curTime = new Date(Date.now() - 86400000)
      return timestampToTime(curTime)
    },
  },
  watch: {
    screenWidth() {
      this.getReSize()
    },
  },
  mounted() {
    if (this.curEnv === 'sysu') {
      this.endDay = this.yesterday
      this.startDay = timestampToTime(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000))
    }
    this.getAccessAnalyseApi()
  },
  methods: {
    // 切换日期
    startDayChange(val) {
      let startTimeStamp = new Date(val).getTime()
      if (startTimeStamp == 0) {
        this.endDay = ''
      } else {
        let nextDate = startTimeStamp + this.pickDatePeriod * 24 * 60 * 60 * 1000
        if (nextDate > new Date(this.yesterday).getTime()) {
          this.endDay = this.yesterday
        } else {
          this.endDay = timestampToTime(nextDate)
        }
      }
      if (this.startDay && this.endDay) {
        this.getSearchAccessAnalyseApi()
      }
    },
    endDayChange(val) {
      let endTimeStamp = new Date(val).getTime()
      if (endTimeStamp == 0) {
        this.startDay = ''
      } else {
        let lastDate = endTimeStamp - this.pickDatePeriod * 24 * 60 * 60 * 1000
        this.startDay = timestampToTime(lastDate)
      }
      if (this.startDay && this.endDay) {
        this.getSearchAccessAnalyseApi()
      }
    },
    // 切换查看chart时间周期
    changeChartPeriod(val) {
      if (this.curEnv === 'sysu') {
        this.endDay = this.yesterday
        this.startDay = timestampToTime(new Date(this.yesterday).getTime() - this.pickDatePeriod * 24 * 60 * 60 * 1000)

        this.getSearchAccessAnalyseApi()
      } else {
        if (val == 1) {
          this.iniFlowTrendChart(this.dayChartData)
        } else if (val == 2) {
          this.iniFlowTrendChart(this.monthChartData)
        }
      }
    },
    async getAccessAnalyseApi() {
      await this.$store
        .dispatch('platform/getAccessAnalyse', {})
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.accessData = res.data
            for (let key in this.accessData.table) {
              let rowName = ''
              let rowIndex = 0
              switch (key) {
                case 'today':
                  rowName = '今日'
                  rowIndex = 0
                  break
                case 'top':
                  rowName = '历史最高'
                  rowIndex = 2
                  break
                case 'total':
                  rowName = '历史累计'
                  rowIndex = 3
                  break
                case 'yesterday':
                  rowName = '昨日'
                  rowIndex = 1
                  break
              }
              console.log('rowname', rowName)
              console.log('rowIndex', rowIndex)
              res.data.table[key]['rowIndex'] = rowName
              this.accessTableData.push(res.data.table[key])
            }
            this.accessTableData.sort((a, b) => {
              return a.rowIndex - b.rowIndex
            })
            console.log(this.accessTableData)
            this.iniFlowTrendChart(this.dayChartData)

            this.screenWidth = document.body.clientWidth //监听页面缩放
            this.screenHeight = document.body.clientHeight
            window.onresize = () => {
              return (() => {
                this.screenWidth = document.body.clientWidth
                this.screenHeight = document.body.clientHeight
              })()
            }
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 中大-搜索访问分析数据
    async getSearchAccessAnalyseApi() {
      await this.$store
        .dispatch('platform/getSearchAccessAnalyse', {
          start_time: this.startDay,
          end_time: this.endDay,
          type: this.accessPeriod == 1 ? 'day' : 'month',
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            if (this.accessPeriod == 1) {
              this.accessData.day_chart = res.data
              this.iniFlowTrendChart(this.dayChartData)
            } else if (this.accessPeriod == 2) {
              this.accessData.month_chart = res.data

              this.iniFlowTrendChart(this.monthChartData)
            }
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    iniFlowTrendChart(data) {
      var chart = this.$echarts.init(document.getElementById('flow-trend-chart'))
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['浏览次数', '独立访客', 'IP'],
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: [
          {
            name: '次数',
            type: 'value',
            minInterval: 1,
            nameTextStyle: {
              color: '#98a6ad',
              padding: [20, 40, 20, 0],
              fontSize: '12',
              align: 'center',
            },
          },
          {
            name: '人数',
            type: 'value',
            minInterval: 1,
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              color: '#98a6ad',
              padding: [20, 0, 20, 40],
              fontSize: '12',
              align: 'center',
            },
          },
        ],
        series: [
          {
            name: '浏览次数',
            data: data.browserTimes,
            type: 'line',
            yAxisIndex: 0,
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '独立访客',
            data: data.uniqueVisitor,
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              color: '#F86262',
            },
          },
          {
            name: 'IP',
            data: data.ip,
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              color: '#44CF9C',
            },
          },
        ],
      }
      chart.setOption(option)
      this.flowTrendChart = chart
    },
    getReSize() {
      let chartArr = [this.flowTrendChart]
      for (let i = 0; i < chartArr.length; i++) {
        //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          if (chartArr[i]) {
            chartArr[i].resize()
          }
        }, 200)
      }
    },
    exportTable() {
      //导出名称
      let excelName = '访问分析' + new Date().getTime() + '.xlsx'
      const xlsxParam = { raw: true } //转化成Excel使用原始格式
      const table_book = this.$XLSX.utils.table_to_book(document.querySelector('#access-analyse-table'), xlsxParam)
      const table_write = this.$XLSX.write(table_book, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        this.$FileSaver.saveAs(new Blob([table_write], { type: 'application/octet-stream' }), excelName)
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, table_write)
      }
      return table_write
    },
  },
}
</script>
<style lang="scss" scoped>
.page-title-box {
  h4.page-title {
    font-weight: 600;
  }
  .date-range {
    color: rgba(108, 117, 125, 1);
    font-size: 14px;
  }
}
.date-picker {
  flex-shrink: 0;
  margin-left: 12px;
  background-color: #f3f7f9;
}
.chart-title {
  font-size: 16px;
  font-weight: bold;
  color: #6c757d;
}
.chart-card {
  width: 100%;
}
.timerange {
  padding: 12px 0;
}
</style>
